import { useQuery } from "react-query";
import { getRisk } from "../../../../../actions/Utilities/Risk";

export default function useGetRisk() {
  return useQuery("GetRisk", getRisk, {
    refetchOnWindowFocus: false,
  });
}
